import { createSlice } from '@reduxjs/toolkit'

export interface Item {
    id: number,
    title: string,
    description: string,
    deadline: string,
    status: 'new' | 'in process' | 'done'
}

const initialState : Item[] = []

const TodoSlice = createSlice({
    name: 'todos',
    initialState,
    reducers: {
        addTodo: (state, {payload}) => {
            state.push(payload)
        },
        toggleStatus(state, {payload}) {
            let task = state.find(item => item.id === payload.id)
            if(task) {
                task.status = payload.status
            }
        },
        updateTodo(state, {payload}) {
            let task = state.find(item => item.id === payload.id)

            if (task) {
                task.title = payload.title
                task.description = payload.description
                task.deadline = payload.deadline
            }

        }
    }
})

export const selectNewTodos = (state: any) => state.todos.filter((item: Item) => item.status === 'new')

export const { addTodo, updateTodo, toggleStatus } = TodoSlice.actions

export default TodoSlice.reducer